import { Icon, Tooltip } from '@nike/eds'
import { PropsWithChildren, useState } from 'react'

export interface GeneralTooltipProps {
  body: any
  anchorElement?: any
}

export function GeneralTooltip({ body, anchorElement }: PropsWithChildren<GeneralTooltipProps>) {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)

  let timeout: NodeJS.Timeout
  const showTooltip = () => {
    timeout = setTimeout(() => {
      setIsTooltipVisible(true)
    }, 400)
  }

  const hideTooltip = () => {
    clearInterval(timeout)
    setIsTooltipVisible(false)
  }

  if (body) {
    return (
      <Tooltip
        isOpen={isTooltipVisible}
        isDark={true}
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={hideTooltip}
        bodySlot={body}
        placement={'right-start'}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 0],
            },
          },
        ]}
      >
        <div
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
          style={{
            borderRight: '15px solid transparent',
            borderBottom: '50px solid transparent',
            marginBottom: '-50px',
          }}
        >
          {anchorElement ? (
            anchorElement
          ) : (
            <Icon name="InfoCircle" size="s" className="eds-spacing--ml-4 no-flex-shrink" />
          )}
        </div>
      </Tooltip>
    )
  } else {
    return null
  }
}
